import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { CheckEmail } from './pages/CheckEmail';
import { VerifyEmail } from './pages/VerifyEmail';
import { SetupPayment } from './pages/SetupPayment';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { Dashboard } from './pages/Dashboard';
import ConnectWhatsApp from './pages/ConnectWhatsApp';
import UserManagement from './pages/UserManagement';
import UserWhatsAppSettings from './pages/UserWhatsAppSettings';
import './App.css';

// Simple auth check
const isAuthenticated = () => {
  return localStorage.getItem('token') !== null || localStorage.getItem('access_token') !== null;
};

// Protected route component
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Authentication Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/check-email" element={<CheckEmail />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/setup-payment" element={<SetupPayment />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Protected Dashboard Routes - using /* to capture all subroutes */}
            <Route path="/dashboard/*" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />

            {/* WhatsApp connection flow (after OAuth install) */}
            <Route path="/connect-whatsapp/:locationId" element={
              <ProtectedRoute>
                <ConnectWhatsApp />
              </ProtectedRoute>
            } />

            {/* User Management Routes */}
            <Route path="/user-management/:locationId" element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            } />

            <Route path="/user-whatsapp/:locationId/:userId" element={
              <ProtectedRoute>
                <UserWhatsAppSettings />
              </ProtectedRoute>
            } />

            {/* Public QR code endpoint - accessible via custom menu */}
            <Route path="/whatsapp/qr-latest/:locationId/:userId?" element={
              <div>Redirecting...</div>
            } />
            
            {/* Default Route */}
            <Route path="/" element={
              isAuthenticated() ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
            } />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;

